/** Select options built from what the API actually returned — never a hard-coded list. */
export interface SelectOption { value: string; label: string }

export function optionsFrom<T>(rows: T[], pick: (row: T) => string | number | null | undefined, label?: (v: string) => string): SelectOption[] {
  const seen = new Map<string, string>();
  for (const r of rows) {
    const v = pick(r);
    if (v === null || v === undefined || v === '') continue;
    const key = String(v);
    if (!seen.has(key)) seen.set(key, label ? label(key) : key);
  }
  return [...seen.entries()].sort((a, b) => a[1].localeCompare(b[1])).map(([value, l]) => ({ value, label: l }));
}

export const RESULT_OPTIONS: SelectOption[] = [
  { value: 'recorded', label: 'Recorded in Anatomy' },
  { value: 'queued', label: 'Queued for Anatomy’s admin' },
  { value: 'failed', label: 'Failed' },
];

export const resultOf = (r: { success: boolean; queued: boolean }) => (!r.success ? 'failed' : r.queued ? 'queued' : 'recorded');

/** Inclusive day-range test on a yyyyMMddHHmmss stamp. */
export function inDateRange(stamp: number | null | undefined, from: Date | null, to: Date | null): boolean {
  if (!from && !to) return true;
  if (!stamp) return false;
  const s = String(Math.trunc(stamp)).padStart(14, '0');
  const d = new Date(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8));
  if (from && d < new Date(from.getFullYear(), from.getMonth(), from.getDate())) return false;
  if (to && d > new Date(to.getFullYear(), to.getMonth(), to.getDate(), 23, 59, 59)) return false;
  return true;
}

/** Anatomy marks a type that is not campus-specific with "-" (its documentation says "--"). */
export const isAllCampuses = (c?: string | null) => !c || /^-+$/.test(c.trim());
export const campusLabel = (c?: string | null) => (isAllCampuses(c) ? 'All campuses' : c!);

/** Where a request came from: the console, or an external system by its `source` ("WhatsApp", "Website"). Never shows the user id itself. */
export function originOf(userId?: string | null): string {
  if (!userId) return 'Console';
  if (userId.startsWith('external:')) { const src = userId.slice('external:'.length).trim(); return src && src !== 'api' ? src : 'External API'; }
  return 'Console';
}
export const isExternal = (userId?: string | null) => !!userId && userId.startsWith('external:');
